export enum MDSLoadingArrowsSize {
  Small = "small",
  Smedium = "smedium",
  Medium = "medium",
  Large = "large",
  XSmall = "xsmall",
}

export interface MDSLoadingArrowsProps {
  /** Size of the loading dots animation */
  size?: MDSLoadingArrowsSize;
  /** Optional class name for additional styling */
  className?: string;
  /** Whether the animation should loop continuously */
  loop?: boolean;
  /** Animation speed multiplier (1.0 is normal speed) */
  speed?: number;
}
